/* Homepage runtime for the native home-* sections (ported from Instant, 2026-10-08).
   Replaces what Instant's instant-core did on these blocks: Swiper sliders (same params JSON), tabs,
   tickers, variant selects, add to cart through the theme's cart drawer, redirect-to-cart, open-page. */
(function () {
  if (window.__mmhome) return;
  window.__mmhome = true;

  var SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function loadSwiper(cb) {
    if (window.Swiper) return cb();
    var s = document.querySelector('script[src="' + SWIPER_SRC + '"]');
    if (!s) {
      s = document.createElement('script');
      s.src = SWIPER_SRC;
      s.async = true;
      document.head.appendChild(s);
    }
    s.addEventListener('load', function () { cb(); });
    var tries = 0;
    var t = setInterval(function () {
      if (window.Swiper || ++tries > 100) { clearInterval(t); if (window.Swiper) cb(); }
    }, 100);
  }

  /* ---- sliders ---- */
  function initSliders(scope) {
    scope.querySelectorAll('script[type="application/json"][id^="mmhome-slider-"][id$="-params"]').forEach(function (sc) {
      var id = sc.id.slice('mmhome-slider-'.length, -'-params'.length);
      var el = document.getElementById(id);
      if (!el || el.swiper || el.__mmhomeInit) return;
      var params;
      try { params = JSON.parse(sc.textContent); } catch (e) { return; }
      // Swiper ignores autoplay inside breakpoints; hoist it when every breakpoint agrees
      var bps = params.breakpoints ? Object.keys(params.breakpoints).map(function (k) { return params.breakpoints[k]; }) : [];
      if (bps.length && bps.every(function (b) { return JSON.stringify(b.autoplay) === JSON.stringify(bps[0].autoplay); }) && bps[0].autoplay) {
        params.autoplay = bps[0].autoplay.enabled ? bps[0].autoplay : false;
        bps.forEach(function (b) { delete b.autoplay; });
      }
      el.__mmhomeInit = true;
      new window.Swiper(el, params);
    });
  }

  function updateSliders(scope) {
    scope.querySelectorAll('[data-mmhome-type="slider"]').forEach(function (s) { if (s.swiper) s.swiper.update(); });
  }

  /* ---- tabs ---- */
  function initTabs(scope) {
    scope.querySelectorAll('[data-mmhome-type="tabs-container"]').forEach(function (tc) {
      if (tc.__mmhomeTabs) return;
      tc.__mmhomeTabs = true;
      var triggers = tc.querySelectorAll('[data-mmhome-type="tabs-trigger"]');
      var panes = tc.querySelectorAll('[data-mmhome-type="tabs-pane"]');
      function show(tabId) {
        triggers.forEach(function (t) {
          t.setAttribute('data-mmhome-state', t.getAttribute('data-mmhome-tab-id') === tabId ? 'active' : 'inactive');
        });
        panes.forEach(function (p) {
          var on = p.id === tabId;
          p.setAttribute('data-mmhome-state', on ? 'open' : 'closed');
          p.style.display = on ? '' : 'none';
          if (on) updateSliders(p);
        });
      }
      triggers.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-mmhome-tab-id')); });
      });
      var active = tc.querySelector('[data-mmhome-type="tabs-trigger"][data-mmhome-state="active"]') || triggers[0];
      if (active) show(active.getAttribute('data-mmhome-tab-id'));
    });
  }

  /* ---- tickers: fill the strip with copies, then animate at data-speed px per second ---- */
  function buildTicker(c) {
    var tickers = [].filter.call(c.children, function (k) { return k.classList.contains('mmhome-ticker'); });
    if (!tickers.length) return;
    var first = tickers[0];
    var second = tickers[1];
    if (!second) {
      second = document.createElement('div');
      second.className = 'mmhome-ticker';
      c.appendChild(second);
    }
    var initial = first.querySelector('.mmhome-ticker-initial-child-container');
    if (!initial) return;
    [].slice.call(first.children).forEach(function (k) { if (k !== initial) first.removeChild(k); });
    second.innerHTML = '';
    var items = [].slice.call(initial.children);
    var cw = c.getBoundingClientRect().width;
    var iw = initial.getBoundingClientRect().width;
    if (!items.length || !cw || !iw || getComputedStyle(c).display === 'none') return;
    var gap = parseFloat(getComputedStyle(c).columnGap) || 0;
    // Instant's math: copies = strip width / item width (gaps not counted), loop time = copies x item width / speed
    var m = Math.max(1, Math.ceil(cw / iw));
    var i, j;
    for (i = 1; i < m; i++) items.forEach(function (it) { first.appendChild(it.cloneNode(true)); });
    for (j = 0; j < m; j++) items.forEach(function (it) { second.appendChild(it.cloneNode(true)); });
    var speed = parseFloat(c.getAttribute('data-mmhome-ticker-speed')) || 50;
    var w = m * iw;
    c.style.setProperty('--gap', gap + 'px');
    c.style.setProperty('--play', 'running');
    c.style.setProperty('--direction', c.getAttribute('data-mmhome-ticker-is-reversed') === 'true' ? 'reverse' : 'normal');
    c.style.setProperty('--duration', (w / speed) + 's');
    c.style.setProperty('--pause-on-hover', c.getAttribute('data-mmhome-ticker-pause') === 'true' ? 'paused' : 'running');
    c.style.setProperty('--multiplier', m);
  }

  function initTickers(scope) {
    scope.querySelectorAll('[data-mmhome-type="ticker"]').forEach(buildTicker);
  }

  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    clearTimeout(window.__mmhomeResize);
    window.__mmhomeResize = setTimeout(function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      initTickers(document);
    }, 200);
  });

  /* ---- variant selects ---- */
  function moneyLike(sample, cents) {
    var prefix = (sample.match(/^[^0-9]*/) || [''])[0];
    var amount = cents / 100;
    var text = /[.,]\d{2}\b/.test(sample) ? amount.toFixed(2) : String(Math.round(amount));
    return prefix + text;
  }

  function scopeFor(el) {
    var n = el.parentElement;
    while (n && !n.querySelector('[data-mmhome-action-variant-id]')) n = n.parentElement;
    return n;
  }

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('.mmhome select[name*="__"]')) return;
    var key = sel.name.split('__')[0];
    var vs = document.querySelector('script[id^="variants__' + key + '--"]');
    var scope = scopeFor(sel);
    if (!vs || !scope) return;
    var variants;
    try { variants = JSON.parse(vs.textContent); } catch (err) { return; }
    var atc = scope.querySelector('[data-mmhome-action-variant-id]');
    var currentId = Number(atc.getAttribute('data-mmhome-action-variant-id'));
    var current = variants.filter(function (v) { return v.id === currentId; })[0];
    var opt = sel.options[sel.selectedIndex];
    var pos = parseInt((opt.id || '').split('-')[1], 10) || 1;
    var want = current ? current.options.slice() : [];
    want[pos - 1] = sel.value;
    var v = variants.filter(function (x) { return x.options.every(function (o, i) { return want[i] == null || o === want[i]; }); })[0] ||
            variants.filter(function (x) { return x.options[pos - 1] === sel.value; })[0];
    if (!v) return;

    atc.setAttribute('data-mmhome-action-variant-id', v.id);
    atc.setAttribute('data-mmhome-disabled', v.available ? '' : 'true');
    if (atc.getAttribute('href')) atc.setAttribute('href', atc.getAttribute('href').replace(/\/\d+:1/, '/' + v.id + ':1'));
    var form = scope.closest('form') || scope;
    if (form.hasAttribute('data-mmhome-form-variant-id')) form.setAttribute('data-mmhome-form-variant-id', v.id);
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = v.id;
    var price = scope.querySelector('[data-mmhome-dynamic-content-source="PRICE"]');
    if (price) price.textContent = moneyLike(price.textContent.trim(), v.price);
    var img = scope.querySelector('img[data-mmhome-dynamic-content-source="FEATURED_IMAGE"]');
    if (img && v.featured_image && v.featured_image.src) {
      img.removeAttribute('srcset');
      img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1280';
      if (v.featured_image.alt) img.alt = v.featured_image.alt;
    }
    var label = sel.closest('fieldset') && sel.closest('fieldset').querySelector('[data-mmhome-type="selected-variant-option"]');
    if (label) label.textContent = sel.value;
  });

  /* ---- clicks: add to cart, redirect to cart, open page ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.mmhome [data-mmhome-action-type="add-to-cart"], .mmhome [data-mmhome-action-type="redirect-to-cart"]');
    if (a) {
      e.preventDefault();
      e.stopPropagation();
      if ((a.getAttribute('data-mmhome-disabled') || '').trim() === 'true') return;
      var vid = a.getAttribute('data-mmhome-action-variant-id');
      var form = a.closest('form');
      var idInput = form && form.querySelector('input[name="id"]');
      if (a.getAttribute('data-mmhome-action-type') === 'add-to-cart' && idInput && document.querySelector('cart-drawer')) {
        idInput.value = vid;
        document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: a } }));
        return;
      }
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = ROOT + 'cart';
      }).catch(function () { window.location.href = a.href; });
      return;
    }
    var o = e.target.closest && e.target.closest('.mmhome [data-mmhome-action-type="open-page"][data-mmhome-href]');
    if (o && o.tagName !== 'A' && !e.target.closest('a, button, select, input, label, fieldset')) {
      window.location.href = o.getAttribute('data-mmhome-href');
    }
  }, true);

  function init(scope) {
    initTabs(scope);
    loadSwiper(function () { initSliders(scope); updateSliders(scope); });
    initTickers(scope);
  }

  ready(function () {
    init(document);
    // fonts change text widths, so rebuild tickers once they're in
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { initTickers(document); });
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
